/**
 * PageShell — the centered card layout shared by PostDeletionLanding and
 * AccountDeleteWebPage. Mirrors the prototype's PageShell so the full-
 * page erasure surfaces match the rest of the auth-less web kit.
 */

import { ChromeTokens } from "../chrome/tokens";

const tokens = ChromeTokens;

interface Props {
  maxWidth?: number;
  children: React.ReactNode;
}

export function PageShell({ maxWidth = 520, children }: Props): JSX.Element {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: tokens.spacing.xl,
        background: tokens.color.sky,
      }}
    >
      <div style={{ width: "100%", maxWidth }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: tokens.spacing.lg,
            fontFamily: tokens.font.ui,
            fontWeight: 800,
            fontSize: 26,
            letterSpacing: "-.015em",
            color: tokens.color.ink,
            lineHeight: 1,
            whiteSpace: "nowrap",
          }}
        >
          <span>world</span>
          <span style={{ opacity: 0.62, fontWeight: 700, margin: "0 .22em" }}>by</span>
          <span style={{ color: tokens.color.coral }}>me</span>
        </div>
        <div
          style={{
            background: tokens.color.base,
            borderRadius: tokens.radius.lg,
            boxShadow: tokens.shadow.lifted,
            padding: "32px 30px",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
